module.exports = __webpack_public_path__ + "img/logo-clover.c01f4a3b.svg";